// extracted by mini-css-extract-plugin
export default {"main":"Home_main__19nnz","header":"Home_header__hx6ZQ","logo":"Home_logo__tseYk","card":"Home_card__ehRyT","rotate":"Home_rotate__hmS7d"};